import { Link } from "react-router-dom";
import { Zap, BadgeCheck, ShieldCheck } from "lucide-react";

const BADGES = [
  { icon: Zap, t: "Devis rapide", d: "Estimation en quelques clics" },
  {
    icon: BadgeCheck,
    t: "Déménageur professionnel",
    d: "Équipes qualifiées · assurance Allianz",
  },
  {
    icon: ShieldCheck,
    t: "Gratuit sans engagement",
    d: "Aucune obligation, aucun frais caché",
  },
];

export default function DevisLayout({ children }) {
  return (
    <div className="min-h-screen flex flex-col bg-white">
      {/* Header minimal — logo seul */}
      <header
        data-testid="devis-layout-header"
        className="sticky top-0 z-50 bg-white border-b border-[#e6edf3]"
      >
        <div className="bd-container flex items-center justify-between h-16 sm:h-20">
          <Link to="/" className="flex items-center shrink-0" aria-label="Big Déménagement · Retour à l'accueil">
            <picture>
              <source media="(min-width: 640px)" srcSet="/big-demenagement-logo-desktop.webp" />
              <img
                src="/big-demenagement-logo-mobile.webp"
                alt="Logo Big Déménagement — devis déménagement gratuit"
                width="260"
                height="92"
                className="h-10 sm:h-12 w-auto"
                loading="eager"
                decoding="async"
              />
            </picture>
          </Link>
        </div>
      </header>

      {/* Main content */}
      <main className="flex-1 bg-[#f7fafc]">{children}</main>

      {/* Footer minimal — badges only (même fond que le main) */}
      <footer
        data-testid="devis-layout-footer"
        className="bg-[#f7fafc] pb-10 sm:pb-14 pt-2"
      >
        <div className="bd-container max-w-5xl">
          <ul className="grid grid-cols-1 sm:grid-cols-3 gap-4">
            {BADGES.map(({ icon: Icon, t, d }) => (
              <li
                key={t}
                className="flex items-start gap-3 rounded-2xl bg-white border border-[#e6edf3] p-5 shadow-[0_4px_12px_-8px_rgba(35,124,181,0.35)]"
              >
                <span className="inline-flex h-11 w-11 items-center justify-center rounded-xl bg-[#eaf3fb] text-[#237cb5] shrink-0">
                  <Icon className="h-5 w-5" />
                </span>
                <div className="min-w-0">
                  <h3 className="text-[14px] font-extrabold text-[#0f1d2b]">{t}</h3>
                  <p className="mt-1 text-[12.5px] text-[#5b6b7a] leading-relaxed">{d}</p>
                </div>
              </li>
            ))}
          </ul>
        </div>
      </footer>
    </div>
  );
}
